// PushOneButton.jsx (파일 이름이 다른게 맞아..귀찮아서 그랬어)

import { useEffect, useState } from 'react';
import { Button, Stack, Typography, useMediaQuery } from '@mui/material';
import { enableWebPush, disableWebPush, getCurrentSubscription } from '../push';

export default function PushOneButton() {
    const [subscribed, setSubscribed] = useState(false);
    const [loading, setLoading] = useState(true);
    const [perm, setPerm] = useState(typeof Notification !== 'undefined' ? Notification.permission : 'default');

    const isMobile = useMediaQuery('(max-width:600px)'); // ✅ 모바일 감지

    useEffect(() => {
        (async () => {
            try {
                const sub = await getCurrentSubscription();
                setSubscribed(!!sub);
            } finally {
                setPerm(typeof Notification !== 'undefined' ? Notification.permission : 'default');
                setLoading(false);
            }
        })();
    }, []);

    const handleToggle = async () => {
        if (loading) return;
        try {
            setLoading(true);

            if (typeof Notification !== 'undefined' && Notification.permission === 'denied') {
                alert('브라우저 알림이 차단되어 있습니다. 사이트 권한을 허용해 주세요.');
                return;
            }

            if (subscribed) {
                await disableWebPush();
                setSubscribed(false);
                alert('푸시 알림이 해제되었습니다.');
            } else {
                await enableWebPush(); // 서버에서 public key 자동 로드
                setSubscribed(true);
                alert('푸시 알림이 활성화되었습니다.');
            }
        } catch (e) {
            alert(e?.message || '푸시 설정 중 오류 발생');
        } finally {
            setPerm(typeof Notification !== 'undefined' ? Notification.permission : 'default');
            setLoading(false);
        }
    };

    const label = subscribed ? '푸시 알림 끄기' : '푸시 알림 켜기';
    const variant = subscribed ? 'outlined' : 'contained';

    return (
        <Stack spacing={1}>
            <Button variant={variant} onClick={handleToggle} disabled={loading}>
                {loading ? '확인 중…' : label}
            </Button>

            {/* ✅ PC에서는 설명도 같이 출력 */}
            {!isMobile && (
                <Typography variant="caption" color="text.secondary">
                    권한: {perm} / 상태: {subscribed ? 'ON' : 'OFF'}
                    · iPhone은 홈 화면에 추가(PWA) 시 표시됩니다.
                </Typography>
            )}
        </Stack>
    );
}
